import React from "react";

function PartnerMarquee() {
  const logos = [
    {
      src: "/images/logo-stek.webp",
      alt: "Stek Nederland",
    },
    {
      src: "/images/co-vrij.webp",
      alt: "CO Vrij",
    },
    {
      src: "/images/install-q.webp",
      alt: "Install Q",
    },
    {
      src: "/images/tech-nl.webp",
      alt: "Techniek Nederland",
    },
    {
      src: "/images/vebi.png",
      alt: "VEBIDAK",
    },
  ];

  // Duplicate logos for seamless scrolling
  const allLogos = [...logos, ...logos, ...logos, ...logos];

  return (
    <div className="my-2 max-w-7xl mx-auto">
      <div className="flex flex-col w-full">
        <div className="relative mt-2 mb-2 overflow-hidden w-full">
          {/* Right gradient overlay */}
          <div className="absolute left-auto w-12 right-0 inset-0 bg-gradient-to-l from-white to-transparent pointer-events-none z-10" />
          {/* Left gradient overlay */}
          <div className="absolute inset-0 w-12 right-auto left-0 bg-gradient-to-r from-white to-transparent pointer-events-none z-10" />

          {/* Scrolling content */}
          <div className="flex gap-x-6 whitespace-nowrap animate-marquee">
            {allLogos.map((logo, index) => (
              <span
                key={index}
                className="inline-block rounded-lg border bg-white"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="max-w-[65px] md:max-w-[130px] h-auto mx-2"
                />
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerMarquee;
